<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="https://www.aileron.org/privacy-policy/">Privacy Policy</a>
          </li>
          <li>
            <a href="https://www.aileron.org/terms-and-conditions/">Terms and Conditions</a>
          </li>
          <li>
            <a href="https://www.aileron.org/nondiscriminatory-policy/">Nondiscriminatory Policy</a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
       <div class="copyright">&copy; {{ year }}, <a href="https://www.aileron.org/" target="_blank">Aileron All Rights Reserved</a></div>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data() {
      return {
        year: new Date().getFullYear()
      };
    }
  }

</script>
<style>

</style>
